import { apiConstants } from "../../config";
import {
  apiPost,
  apiPut,
  apiGet,
  apiDelete
} from "../../../../shared/services";

const fetchItems = async options => {
  const url = apiConstants.url;
  return await apiGet(url, { params: options });
};

const saveItem = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.url + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.url;
    return await apiPost(url, { ...data }, validator);
  }
};

const fetchItem = async id => {
  const url = apiConstants.url;
  return await apiGet(url + "/" + id);
};

const deleteItem = async id => {
  const url = apiConstants.url;
  return await apiDelete(url + "/" + id);
};

const saveUdValue = async (id, data, validator) => {
  if (id) {
    let url = apiConstants.udvalue + "/" + id;
    return await apiPut(url, { ...data }, validator);
  } else {
    let url = apiConstants.udvalue;
    return await apiPost(url, { ...data }, validator);
  }
};

const deleteUdValue = async id => {
  const url = apiConstants.udvalue;
  return await apiDelete(url + "/" + id);
};

const duplicateUdValue = async id => {
  const url = apiConstants.url;
  return await apiPost(url + "/" + id + "/duplicate");
};

export {
  fetchItems,
  saveItem,
  deleteItem,
  fetchItem,
  saveUdValue,
  deleteUdValue,
  duplicateUdValue
};
